"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const settlementRequestDataState_1 = __importDefault(require("@/room/settlement_request/settlementRequestDataState"));
const showCompanyRegisterDialogState_1 = __importDefault(require("@/common/components/CompanyRegisterDialog/showCompanyRegisterDialogState"));
const react_i18next_1 = require("react-i18next");
const detect_utils_1 = require("@/common/detect_utils");
const CompanyRegisterDialog_1 = require("@/common/components/CompanyRegisterDialog");
const Collapse_1 = __importDefault(require("@mui/material/Collapse"));
const Button_1 = __importDefault(require("@mui/material/Button"));
const settlement_request_1 = require("@/room/settlement_request");
function default_1({ expandCompanyInfoButtons, setValue, }) {
    const [showCompanyDeleteDialog, setShowCompanyDeleteDialog] = (0, react_1.useState)(false);
    const openCompanyDeleteDialog = () => setShowCompanyDeleteDialog(true);
    const closeCompanyDeleteDialog = () => setShowCompanyDeleteDialog(false);
    const unmountRef = (0, detect_utils_1.useUnmountRef)();
    const closeMountedDialog = () => {
        if (!unmountRef.current)
            closeCompanyDeleteDialog();
    };
    const [{ user_id: userId }, setSettlementRequestData] = (0, recoil_1.useRecoilState)(settlementRequestDataState_1.default);
    const onCompanyInfoDeleteSuccess = () => {
        (0, settlement_request_1.invalidateSettlementCompanyData)({ setSettlementRequestData, setValue });
    };
    const setShowCompanyRegisterDialog = (0, recoil_1.useSetRecoilState)(showCompanyRegisterDialogState_1.default);
    const openCompanyRegisterDialog = () => setShowCompanyRegisterDialog(true);
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Collapse_1.default, Object.assign({ in: expandCompanyInfoButtons, timeout: 150 }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ css: {
                        display: 'flex',
                        justifyContent: 'flex-end',
                        columnGap: '10px',
                        padding: '12px 16px',
                        '> button': {
                            width: '130px',
                            height: '32px',
                            padding: '0 12px',
                            borderRadius: '8px',
                            color: 'var(--gray-80)',
                            backgroundColor: 'var(--white) !important',
                        },
                    } }, { children: [(0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: openCompanyDeleteDialog, sx: { border: '1px solid var(--gray-10)' } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body3" }, { children: t('사업자 정보 폐기') })) })), (0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ onClick: openCompanyRegisterDialog, sx: { border: '1px solid var(--gray-80)' } }, { children: (0, jsx_runtime_1.jsx)("span", Object.assign({ className: "body3" }, { children: t('사업자 정보 보기') })) }))] })) })), (0, jsx_runtime_1.jsx)(CompanyRegisterDialog_1.CompanyDeleteDialog, { open: showCompanyDeleteDialog, closeDialog: closeMountedDialog, userId: userId, onCompanyInfoDeleteSuccess: onCompanyInfoDeleteSuccess })] }));
}
exports.default = default_1;
